import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DropdownOptionData } from './column-filter-dropdown-option-data';

@Component({
    selector: 'jhi-column-filter-dropdown',
    template: `
        <form #f='ngForm'>
            <section class="filter-wrapper">
                <div id="dropdown-container-{{this.filter.key}}">
                    <ng-select width="170px"
                               [name]="'dropdownFilter' + this.filter.key"
                               [id]="'dropdownFilter' + this.filter.key"
                               bindValue="id"
                               bindLabel="text"
                               [placeholder]=" selectPlaceholder | translate"
                               [clearable]="false"
                               [(ngModel)]="selectedValues"
                               [items]="this.values"
                               [multiple]="multipleSelect"
                               [addTag]="true">
                    </ng-select>
                </div>
            </section>
            <div *ngIf="this.multipleSelect"><span>{{ 'column-filter.multiple.values.select' | translate }}</span></div>
            <div *ngIf="!this.multipleSelect"><span>{{ 'column-filter.single.value.select' | translate }}</span></div>
            <br/>
            <div class="footer text-center"><br>
                <button type="submit" class="btn btn-primary btn-sm me-1" [disabled]="!f.valid" (click)="apply(f)">{{ 'apply' | translate }}</button>
                <button class="btn btn-secondary btn-sm" (click)="reset(f)">{{ 'reset' | translate }}</button>
            </div>
        </form>
    `
})
export class ColumnFilterDropdownComponent implements OnInit {

    values: DropdownOptionData[];
    selectedValues: string[];
    multipleSelect: boolean;
    options;
    selectPlaceholder: string;

    @Input() filter: any;

    @Output() onApply = new EventEmitter();
    @Output() onReset = new EventEmitter();

    constructor() {
    }

    async ngOnInit() {
        if (this.filter.selectedValues) {
            this.selectedValues = this.filter.selectedValues.map((value: DropdownOptionData) => value.id);
        }
        this.multipleSelect = (this.filter.multipleSelect) ? this.filter.multipleSelect : false;
        this.selectPlaceholder = this.multipleSelect ?  'column-filter.select.options' : 'column-filter.select.option';
        this.values = await this.filter.values;
    }

    apply(form) {
        if (!form.valid) {
            return;
        }

        const selectedArray = Array.isArray(this.selectedValues)
            ? this.selectedValues
            : [this.selectedValues];
        const selectedValuesSet = new Set(selectedArray);
        this.filter['selectedValues'] = this.values.filter((value: DropdownOptionData) => selectedValuesSet.has(value.id));
        this.onApply.emit();
    }

    reset(form) {
        form.reset();
        this.onReset.emit();
    }

}
